import React, { useState } from "react";
import styles from "./copy-to-clipboard.module.css";
import { Placement, Tooltip } from "../Tooltip/Tooltip";
import IconCopyClipboard from "../icons/IconCopyClipboard";
import IconCheck from "../icons/IconCheck";

type CopyToClipBoardProps = {
  value: string;
  tooltipText: string;
  tooltipPlacement?: Placement;
  children?: React.ReactNode;
};

/**
 * @param value - The value thats copied to the clipboard when the icon is clicked.
 * @param tooltipText - The text to be rendered inside the tooltip.
 * @param tooltipPlacement - The position of the tooltip. Default is "right".
 * @param children - React Node
 */
const CopyToClipBoard = ({
  value,
  tooltipText,
  tooltipPlacement = "right",
  children,
}: CopyToClipBoardProps) => {
  const [mouseEntered, setMouseEntered] = useState<boolean>(false);
  const [copied, setCopied] = useState<boolean>(false);

  const copyValueToClipboard = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    setCopied(true);
  };

  const handleMouseEnter = () => {
    setMouseEntered(true);
  };

  const handleMouseLeave = () => {
    setMouseEntered(false);
    setCopied(false);
  };

  return (
    <div
      className={styles.clipboardContainer}
      onClick={copyValueToClipboard}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      <Tooltip title={tooltipText} placement={tooltipPlacement}>
        <div className={styles.iconContainer}>
          {mouseEntered && copied ? (
            <IconCheck size={20} />
          ) : (
            <IconCopyClipboard size={20} />
          )}
        </div>
      </Tooltip>
    </div>
  );
};

export default CopyToClipBoard;